import React, {createContext, useContext, useState, useEffect} from 'react'
import {DefaultLayoutConfig} from './DefaultLayoutConfig'
import {
  getEmptyCssClasses,
  getEmptyCSSVariables,
  getEmptyHTMLAttributes,
  LayoutSetup,
} from './LayoutSetup'
import {
  ILayout,
  ILayoutCSSVariables,
  ILayoutCSSClasses,
  ILayoutHTMLAttributes,
} from './LayoutModels'
import {getMessagingToken, onMessageListener} from '../../../untils/firebase'
import {useAuth} from '../../../app/modules/auth/core/Auth'
import {message, Modal} from 'antd'
import NotificationService from '../../../services/handler/notifications/notifications.service'
import {Role} from '../../../app/modules/auth/core/_models'
import axios from 'axios'

export interface LayoutContextModel {
  config: ILayout
  classes: ILayoutCSSClasses
  attributes: ILayoutHTMLAttributes
  cssVariables: ILayoutCSSVariables
  setLayout: (config: LayoutSetup) => void
}

const LayoutContext = createContext<LayoutContextModel>({
  config: DefaultLayoutConfig,
  classes: getEmptyCssClasses(),
  attributes: getEmptyHTMLAttributes(),
  cssVariables: getEmptyCSSVariables(),
  setLayout: (config: LayoutSetup) => {},
})

const enableSplashScreen = () => {
  const splashScreen = document.getElementById('splash-screen')
  if (splashScreen) {
    splashScreen.style.setProperty('display', 'flex')
  }
}

const disableSplashScreen = () => {
  const splashScreen = document.getElementById('splash-screen')
  if (splashScreen) {
    splashScreen.style.setProperty('display', 'none')
  }
}

const LayoutProvider: React.FC = ({children}) => {
  const [config, setConfig] = useState(LayoutSetup.config)
  const [classes, setClasses] = useState(LayoutSetup.classes)
  const [attributes, setAttributes] = useState(LayoutSetup.attributes)
  const [cssVariables, setCSSVariables] = useState(LayoutSetup.cssVariables)
  const {auth, currentUser} = useAuth()
  const setLayout = (_themeConfig: Partial<ILayout>) => {
    enableSplashScreen()
    const bodyClasses = Array.from(document.body.classList)
    bodyClasses.forEach((cl) => document.body.classList.remove(cl))
    LayoutSetup.updatePartialConfig(_themeConfig)
    setConfig(Object.assign({}, LayoutSetup.config))
    setClasses(LayoutSetup.classes)
    setAttributes(LayoutSetup.attributes)
    setCSSVariables(LayoutSetup.cssVariables)
    setTimeout(() => {
      disableSplashScreen()
    }, 500)
  }
  const value: LayoutContextModel = {
    config,
    classes,
    attributes,
    cssVariables,
    setLayout,
  }

  const VIEW_CAMERA = currentUser?.Roles.find((item: Role) => {
    return item.Value === 86
  })

  useEffect(() => {
    if (!auth?.configs || !VIEW_CAMERA) return
    const savedToken = localStorage.getItem('fcm_token')
    if (!savedToken) {
      // getMessagingToken(auth.configs)
    }
  }, [auth?.configs, VIEW_CAMERA])

  const getImage = async (url: string, key: string) => {
    const res = await fetch(url, {
      headers: {
        Authorization: 'Bearer ' + key,
      },
    })

    const blob = await res.blob()
    return URL.createObjectURL(blob)
  }

  useEffect(() => {
    onMessageListener().then(async (payload) => {
      if (payload.data?.Image && payload.data?.ImageKey) {
        const imgUrl = await getImage(payload.data.Image, payload.data.ImageKey)
        Modal.confirm({
          title: payload.notification?.body,
          content: <img src={imgUrl} alt='Camera' style={{width: '100%'}} />,
          okText: 'Phát loa nhắc nhở',
          cancelText: 'Bỏ qua',
          onOk: () => {
            URL.revokeObjectURL(imgUrl)
            NotificationService.confirmNotification(auth?.configs, payload.data)
            message.success('Đã gửi yêu cầu xử lý')
          },
          onCancel: () => {
            URL.revokeObjectURL(imgUrl)
          },
        })
      }
    })
  })

  useEffect(() => {
    disableSplashScreen()
  }, [])

  return <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>
}

export {LayoutContext, LayoutProvider}

export function useLayout() {
  return useContext(LayoutContext)
}
